const getDateFromUnixEpochTimeStamp = (unixTimestamp: number): string => {
  // epoch time is in seconds. We need to get the value in milliseconds
  const date = new Date(unixTimestamp * 1000);
  return date.toLocaleDateString();
};

export default getDateFromUnixEpochTimeStamp;
